define('home/collections/ForumCollection',[
    'core/collections/PaginatedCollection',
    'core/UniqueModel',

    'home/models/Forum',
], function (
    PaginatedCollection,
    UniqueModel,

    Forum
) {
    'use strict';

    var ForumCollection = PaginatedCollection.extend({
        model: UniqueModel.boundModel(Forum),

        parse: function (response) {
            response = PaginatedCollection.prototype.parse.call(this, response);

            return response;
        },
    });

    return ForumCollection;
});

